import _classCallCheck from "/Users/mac/Desktop/Personal-Website-master/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/mac/Desktop/Personal-Website-master/node_modules/@babel/runtime/helpers/esm/createClass";
import { Observable } from 'rxjs-observable';
var ALL = '__ALL__';
var CYCLE_ERROR_MESSAGE = '[undux] Error: Cyclical dependency detected. ' + 'This may cause a stack overflow unless you fix it. \n' + 'The culprit is the following sequence of .set calls, ' + 'called from one or more of your Undux Effects: ';
export var Emitter =
/*#__PURE__*/
function () {
  function Emitter() {
    var isDevMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    _classCallCheck(this, Emitter);

    this.isDevMode = isDevMode;
    this.state = {
      callChain: new Set(),
      observables: new Map(),
      observers: new Map()
    };
  }
  /**
   * Emit an event (silently fails if no listeners are hooked up yet)
   */


  _createClass(Emitter, [{
    key: "emit",
    value: function emit(key, value) {
      if (this.isDevMode) {
        if (this.state.callChain.has(key)) {
          console.error(CYCLE_ERROR_MESSAGE + Array.from(this.state.callChain).concat(key).join(' -> '));
          return this;
        } else {
          this.state.callChain.add(key);
        }
      }

      if (this.hasChannel(key)) {
        this.emitOnChannel(key, value);
      }

      if (this.hasChannel(ALL)) {
        this.emitOnChannel(ALL, value);
      }

      if (this.isDevMode) this.state.callChain.clear();
      return this;
    }
    /**
     * Subscribe to an event
     */

  }, {
    key: "on",
    value: function on(key) {
      return this.createChannel(key);
    }
    /**
     * Subscribe to all events
     */

  }, {
    key: "all",
    value: function all() {
      return this.createChannel(ALL);
    } ///////////////////// privates /////////////////////

  }, {
    key: "createChannel",
    value: function createChannel(key) {
      var _this = this;

      if (!this.state.observers.has(key)) {
        this.state.observers.set(key, []);
      }

      if (!this.state.observables.has(key)) {
        this.state.observables.set(key, []);
      }

      var observable = new Observable(function (_) {
        _this.state.observers.get(key).push(_);

        return function () {
          return _this.deleteChannel(key, observable);
        };
      });
      this.state.observables.get(key).push(observable);
      return observable;
    }
  }, {
    key: "deleteChannel",
    value: function deleteChannel(key, observable) {
      if (!this.state.observables.has(key)) {
        return;
      }

      var array = this.state.observables.get(key);
      var index = array.indexOf(observable);

      if (index < 0) {
        return;
      }

      array.splice(index, 1);

      if (!array.length) {
        this.state.observables.delete(key);
        this.state.observers.delete(key);
      }
    }
  }, {
    key: "emitOnChannel",
    value: function emitOnChannel(key, value) {
      this.state.observers.get(key).forEach(function (_) {
        return _.next(value);
      });
    }
  }, {
    key: "hasChannel",
    value: function hasChannel(key) {
      return this.state.observables.has(key);
    }
  }]);

  return Emitter;
}();